import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { VoucherFilterParams } from '../services'
import { VoucherClientDto } from '../types'
import { defaultQueryOptions, DEFAULT_CACHE_TIME } from './common'
import { ClientVoucherService } from '@services/client_voucher.service'

type Params = VoucherFilterParams & {
  enabled?: boolean
  status?: string
  cacheEnabled?: boolean
  includes?: string[]
  distinguishes?: string[]
}

export const useClientCreditVouchers = (
  locationName: string,
  hookParams: Params = {},
  hasSharedCRM?: boolean
): UseQueryResult<VoucherClientDto[]> => {
  const { enabled = true, cacheEnabled = false, includes = [], ...rest } = hookParams
  const apiParams = {
    ...rest,
    includeShared: !!hasSharedCRM,
    includes: ['location', 'invoiceItem', 'transactions.invoice', ...includes],
  }
  return useQuery<VoucherClientDto[]>({
    queryKey: ['clientVouchers', locationName, apiParams],
    queryFn: () => ClientVoucherService.listCredit(locationName, apiParams),
    ...defaultQueryOptions,
    enabled,
    ...(cacheEnabled ? { staleTime: DEFAULT_CACHE_TIME, cacheTime: DEFAULT_CACHE_TIME } : {}),
  })
}
